import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import TAll from "./3_Analysis/3_0_all"
import TFiveYear from "./3_Analysis/3_0_five"

import * as func from "../../../../utils/functions";
import MAChart from "./3_Analysis/3_1_chart"
import MAJournals from "./3_Analysis/3_2_journals";

class MAnalysis extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// param : {},
			inInit : false,
			activeTab: 'all',
			action: 'resources',
			records : [],
			// totalRecords : '',
			// totalPage : '',
			stats : '',
			// activeTab: id
		}
	}

	componentDidMount() {
		this.getList();
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		}
	}

	getList() {
		// http://127.0.0.1:8000/web/mypage/8490/journal
		func.getData("my_library/stats", this.state.param).then((response) => {
			this.setState({
				inInit : true,
				stats : response.record
			})
		});

		func.getData("my_library/journals", {}).then((response) => {
			this.setState({
				records: response.record,
			})
		});
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	render() {

		// const record = this.props.record;

		if(!this.state.inInit)
			return '';

		// console.log(this.state.stats)
		// if(!this.state.stats)
		// 	return '';

		let stats = null
		if(this.state.stats) {
			stats = this.state.stats;
		}

		return (
			<div className="tab-pane active">
				<div className="mt-px-40">
					<div className="d-flex justify-content-between align-items-center mb-px-26">
						<div className="d-flex align-items-center">
							<h3 className="con-title">연구업적 분석</h3>
						</div>
					</div>
					{stats ?
						<>
							<div className="d-flex align-items-center mb-3">
								<button
									className={"btn-tab-nav mr-1 active-color-lightblue" + (this.state.activeTab === 'all' ? ' active' : '')}
									onClick={() => this.changeTab('all')}>전체 연구성과
								</button>
								<button
									className={"btn-tab-nav mr-1 active-color-lightblue" + (this.state.activeTab === 'five' ? ' active' : '')}
									onClick={() => this.changeTab('five')}>최근 5년간 연구성과
								</button>
							</div>
							<div>
								{this.state.activeTab === 'all' &&
								<TAll stats={this.state.stats}/>
								}
								{this.state.activeTab === 'five' &&
								<TFiveYear stats={this.state.stats}/>
								}
							</div>
						</>
						: '연구 업적 정보가 없습니다.'
					}
				</div>

				{stats && <MAChart stats={this.state.stats} /> }

				{stats && <MAJournals records={this.state.records} /> }

			</div>
		);
	}
};

export default MAnalysis;
